/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { BannerOutputDto } from '../model/bannerOutputDto';
import { BannersViewOutputDto } from '../model/bannersViewOutputDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable({
    providedIn: 'root'
})
export class BannerService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdCity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerBannersByCityGet(cdCity?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<BannersViewOutputDto>>;
    public apiBannerBannersByCityGet(cdCity?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BannersViewOutputDto>>>;
    public apiBannerBannersByCityGet(cdCity?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BannersViewOutputDto>>>;
    public apiBannerBannersByCityGet(cdCity?: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdCity !== undefined && cdCity !== null) {
            queryParameters = queryParameters.set('cdCity', <any>cdCity);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BannersViewOutputDto>>('get', `${this.basePath}/api/Banner/BannersByCity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdBanner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerDeleteDelete(cdBanner: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiBannerDeleteDelete(cdBanner: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiBannerDeleteDelete(cdBanner: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiBannerDeleteDelete(cdBanner: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdBanner === null || cdBanner === undefined) {
            throw new Error('Required parameter cdBanner was null or undefined when calling apiBannerDeleteDelete.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdBanner !== undefined && cdBanner !== null) {
            queryParameters = queryParameters.set('cdBanner', <any>cdBanner);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete', `${this.basePath}/api/Banner/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<BannerOutputDto>>;
    public apiBannerGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BannerOutputDto>>>;
    public apiBannerGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BannerOutputDto>>>;
    public apiBannerGetAllGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BannerOutputDto>>('get', `${this.basePath}/api/Banner/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdBanner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerGetOneGet(cdBanner: number, observe?: 'body', reportProgress?: boolean): Observable<BannerOutputDto>;
    public apiBannerGetOneGet(cdBanner: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BannerOutputDto>>;
    public apiBannerGetOneGet(cdBanner: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BannerOutputDto>>;
    public apiBannerGetOneGet(cdBanner: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdBanner === null || cdBanner === undefined) {
            throw new Error('Required parameter cdBanner was null or undefined when calling apiBannerGetOneGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdBanner !== undefined && cdBanner !== null) {
            queryParameters = queryParameters.set('cdBanner', <any>cdBanner);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BannerOutputDto>('get', `${this.basePath}/api/Banner/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdCity 
     * @param dsImageUrl 
     * @param image 
     * @param isActive 
     * @param nmPosition 
     * @param storesIds 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerPostPostForm(cdCity?: number, dsImageUrl?: string, image?: Blob, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiBannerPostPostForm(cdCity?: number, dsImageUrl?: string, image?: Blob, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiBannerPostPostForm(cdCity?: number, dsImageUrl?: string, image?: Blob, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiBannerPostPostForm(cdCity?: number, dsImageUrl?: string, image?: Blob, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {







        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = true;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (cdCity !== undefined) {
            formParams = formParams.append('CdCity', <any>cdCity) as any || formParams;
        }
        if (dsImageUrl !== undefined) {
            formParams = formParams.append('DsImageUrl', <any>dsImageUrl) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }
        if (isActive !== undefined) {
            formParams = formParams.append('IsActive', <any>isActive) as any || formParams;
        }
        if (nmPosition !== undefined) {
            formParams = formParams.append('NmPosition', <any>nmPosition) as any || formParams;
        }
        if (storesIds) {
            storesIds.forEach((element) => {
                formParams = formParams.append('StoresIds', <any>element) as any || formParams;
            })
        }

        return this.httpClient.request<number>('post', `${this.basePath}/api/Banner/Post`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdBanner 
     * @param cdCity 
     * @param image 
     * @param newImageUrl 
     * @param isActive 
     * @param nmPosition 
     * @param storesIds 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerPutPutForm(cdBanner?: number, cdCity?: number, image?: Blob, newImageUrl?: string, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<BannerOutputDto>;
    public apiBannerPutPutForm(cdBanner?: number, cdCity?: number, image?: Blob, newImageUrl?: string, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BannerOutputDto>>;
    public apiBannerPutPutForm(cdBanner?: number, cdCity?: number, image?: Blob, newImageUrl?: string, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BannerOutputDto>>;
    public apiBannerPutPutForm(cdBanner?: number, cdCity?: number, image?: Blob, newImageUrl?: string, isActive?: boolean, nmPosition?: number, storesIds?: Array<number>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {








        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = true;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (cdBanner !== undefined) {
            formParams = formParams.append('CdBanner', <any>cdBanner) as any || formParams;
        }
        if (cdCity !== undefined) {
            formParams = formParams.append('CdCity', <any>cdCity) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }
        if (newImageUrl !== undefined) {
            formParams = formParams.append('NewImageUrl', <any>newImageUrl) as any || formParams;
        }
        if (isActive !== undefined) {
            formParams = formParams.append('IsActive', <any>isActive) as any || formParams;
        }
        if (nmPosition !== undefined) {
            formParams = formParams.append('NmPosition', <any>nmPosition) as any || formParams;
        }
        if (storesIds) {
            storesIds.forEach((element) => {
                formParams = formParams.append('StoresIds', <any>element) as any || formParams;
            })
        }

        return this.httpClient.request<BannerOutputDto>('put', `${this.basePath}/api/Banner/Put`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdBanner 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiBannerPutStatePut(cdBanner: number, state: boolean, observe?: 'body', reportProgress?: boolean): Observable<BannerOutputDto>;
    public apiBannerPutStatePut(cdBanner: number, state: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BannerOutputDto>>;
    public apiBannerPutStatePut(cdBanner: number, state: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BannerOutputDto>>;
    public apiBannerPutStatePut(cdBanner: number, state: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (cdBanner === null || cdBanner === undefined) {
            throw new Error('Required parameter cdBanner was null or undefined when calling apiBannerPutStatePut.');
        }

        if (state === null || state === undefined) {
            throw new Error('Required parameter state was null or undefined when calling apiBannerPutStatePut.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (cdBanner !== undefined && cdBanner !== null) {
            queryParameters = queryParameters.set('cdBanner', <any>cdBanner);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BannerOutputDto>('put', `${this.basePath}/api/Banner/PutState`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
